<script>

    import {createEventDispatcher} from "svelte";
    import QrCode from "svelte-qrcode";
    import CartItem from "./CartItem.svelte";
    import {cartInfoStore, cartItemsStore, cartTotalStore, confirmOrder} from "./cart-store.js";
    import {publishConfigStore, tenantKeyStore} from "../core/app-store.js";
    import {scrollToElementId} from "../core/utils.js";

    const dispatch = createEventDispatcher();

    export let opened = false;
    export let showTotal = true;

    function close () {
        dispatch('close');
    }

    function confirm (items) {
        confirmOrder(items);
        setTimeout(() => {scrollToElementId('order-qr', 'cart');}, 300);
    }

</script>

<style>
    .cart-container {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        min-height: 100vh;
        overflow-y: auto;
        padding: 1rem;
        background: var(--bg-color);

        bottom: 0;
        right: 0;
        height: 100vh;
        display: flex;
        flex-direction: column;
    }

    h1 {
        font-size: 1.25rem;
        margin: 0;
        padding: 0;
    }

    ul {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        flex: 1 1;
    }
    li {
        border-bottom: 1px solid var(--list-items-separator);
        padding-bottom: 1rem;
    }
    li:last-child {
        border-bottom: none;
    }
    li.no-data {
        text-align: center;
        padding: 2rem 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 1rem;
    }
    li.no-data button {
        padding: 0.75rem 1.5rem;
        border: none;
        border-radius: 1.5rem;
        font-size: inherit;
        font-family: inherit;
        font-weight: 600;
        letter-spacing: .5px;
        color: var(--price-item-font-color);
        background: var(--success-bg-color);
        transition: background-color .2s ease-in-out;
        box-shadow: 0 6px 9px 4px rgb(0 0 0 / 8%);
    }
    .header-block {
        display: flex;
        position: relative;
        padding-top: 1rem;
        padding-bottom: 2.5rem;

    }
    .header-block h1 {
        width: 100%;
        text-align: center;
    }
    .header-block .back-button {
        position: absolute;
        border: none;
        background: none;
        line-height: 1;
        font-size: 1.5rem;
        color: var(--main-font-color);
    }
    .total-block {
        font-weight: 300;
        letter-spacing: .5px;
        display: flex;
        justify-content: space-between;
        border-top: 1px solid var(--list-items-separator);
        padding-top: 1rem;
        padding-bottom: 1rem;
    }
    .confirm-block {
        display: flex;
        justify-content: center;
        padding: 1rem 0;
    }
    .confirm-block button {

        padding: 0.75rem 1.5rem;
        border: none;
        border-radius: 1.5rem;
        font-size: inherit;
        font-family: inherit;
        font-weight: 600;
        letter-spacing: .5px;
        color: var(--price-item-font-color);
        background: var(--price-item-bg-color);
        transition: background-color .2s ease-in-out;
        box-shadow: 0 6px 9px 4px rgb(0 0 0 / 8%);
    }
    .confirm-block--confirmed button {
        background: var(--success-bg-color);
        z-index: 10;
    }
    .order-qr {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background: var(--bg-second-color);
        margin-top: -2.5rem;
        z-index: 0;
        padding: 2rem 1rem;
        border-radius: 2rem;
    }
    .order-qr p {
        text-align: center;
    }
</style>

{#if (opened)}
<div class="layer-cart cart-container" id="cart">

    <div class="header-block">
        <button class="back-button" on:click={close}>
            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai ai-ArrowLeft"><path d="M11 5l-7 7 7 7"/><path d="M4 12h16"/></svg>
        </button>
        <h1>Мой заказ</h1>
    </div>

    <ul>
        {#each $cartItemsStore as item}
        <li>
            <CartItem item={item}
                      publishConfig={$publishConfigStore}
                      tenantKey={$tenantKeyStore}>
            </CartItem>
        </li>
        {/each}

        {#if ($cartItemsStore.length === 0)}
            <li class="no-data">
                <span>В заказе нет позиций</span>
                <button on:click={close}>Открыть список блюд</button>
            </li>
        {/if}
    </ul>


    {#if (showTotal && $cartItemsStore.length > 0)}

        <div class="total-block">
            <span>Итог</span>
            <strong>
                {#if ($publishConfigStore?.currency)}
                {$publishConfigStore.currency}
                {/if}
                { $cartTotalStore?.sum }
            </strong>
        </div>

        <div style="display: none" class="confirm-block {$cartInfoStore.orderData ? 'confirm-block--confirmed' : ''}">
            <button on:click={confirm($cartItemsStore)}>
                {#if (!$cartInfoStore.orderData)}<span>Подтвердить заказ</span>{/if}
                {#if ($cartInfoStore.orderData)}<span>Готово!</span>{/if}
            </button>
        </div>
    {/if}

    {#if ($cartInfoStore.orderData)}
        <div class="order-qr">
            <p>Покажите этот QR-код официанту чтобы он принял заказ</p>
            <div id="order-qr">
                <QrCode value="https://app.digital-menu.ru/o/{$tenantKeyStore}/{$cartInfoStore.orderData}" />
            </div>
        </div>
    {/if}

</div>
{/if}
